import { Link as BPLink } from '@resideo/blueprint-react';
import styled, { css } from 'styled-components';

const sharedStyles = css`
  font-weight: 500;
  margin-bottom: 12px;
  text-decoration: underline;
  width: fit-content;
  :hover,
  :focus {
    color: #004266;
  }
`;

export const StyledLinkDesktop = styled(BPLink)`
  ${sharedStyles}
`;

export const StyledLinkMobile = styled(BPLink)`
  ${sharedStyles}
  font-size: 18px;
`;
